<template>
    <b-form @submit="onSubmit" autocomplete="off" class="form-horizontal">
        <b-row>
            <b-col cols="12" xl="4" class="my-1"> 
                <b-form inline> 
                    <b-button @click="goTo('index')" variant="transparent" size="sm" class="pull-left">
                        <font-awesome-icon icon="angle-left" size="2x" />
                    </b-button>
                    &nbsp;
                    <h3 class="text-themecolor my-1">Release {{command.build}}</h3>
                </b-form>
            </b-col>
            <b-col cols="12" xl="8" class="my-1 no-printable" v-if="command.id">
                <div class="pull-right">
                    <delete title="Release" :id="command.id" namespace="fm" resource="releases" />
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" xl="6">
                <div class="card h-100">
                    <div class="card-body">
                        <h4 class="card-title">{{$t('releases.algemeen')}}</h4>

                        <b-form-group label-cols :label="$t('datatables.naam')">
                            <b-form-input type="text" v-model="command.name" :placeholder="$t('datatables.naam')" />
                        </b-form-group>

                        <b-form-group label-cols :label="$t('datatables.versie')">
                            <b-form-input type="text" :value="release.version" :placeholder="$t('datatables.versie')" disabled />
                        </b-form-group>

                        <b-form-group label-cols label="Build">
                            <b-form-input type="text" :value="command.build" placeholder="Build" disabled />
                        </b-form-group>   

                        <b-form-group label-cols label="Release notes">
                            <b-form-textarea type="text" v-model="command.notes" placeholder="Release notes" :rows="3" :max-rows="6" />
                        </b-form-group>
                        
                        <b-form-group label-cols :label="$t('releases.beschikbaarvanaf')">
                            <b-input-group>
                                <datetime type="datetime" v-model="command.availableFrom" input-class="form-control"></datetime>
                                <b-input-group-append>
                                    <b-button size="sm" @click.stop="clearAvailableFrom()" variant="danger" class="mr-1">
                                        <i class="fa fa-times" aria-hidden="true"></i>
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>

                        <b-form-group label-cols :label="$t('releases.forceerupdate')">
                            <b-form-select v-model="command.forceUpdate">
                                <option :value="true">{{$t('releases.ja')}}</option>
                                <option :value="false">{{$t('releases.nee')}}</option>
                            </b-form-select>
                        </b-form-group>

                        <b-form-group label-cols :label="$t('datatables.status')">
                            <b-form-select v-model="command.active">
                                <option :value="true">{{$t('releases.actief')}}</option>
                                <option :value="false">{{$t('releases.inactief')}}</option>
                            </b-form-select>
                        </b-form-group>
                    </div>
                </div>
            </b-col>
            <b-col cols="12" xl="6">
                <div class="card h-100">
                    <div class="card-body">
                        <h4 class="card-title">{{$t('releases.uitrolinformatie')}}</h4>
                        <b-row>
                            <b-col cols="12" xl="6">
                                <small class="text-muted">{{$t('releases.bedrijven')}}</small>
                            </b-col>
                            <b-col cols="12" xl="6">
                                <h6 class="font-weight-bold">
                                    {{!command.availableForEveryOne ? command.assignedCompanyIds.length : release.totalCompanyCount}} / {{release.totalCompanyCount}}
                                </h6>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" xl="6">
                                <small class="text-muted">{{$t('releases.gebruikers')}}</small>
                            </b-col>
                            <b-col cols="12" xl="6">
                                <h6 class="font-weight-bold">
                                    {{!command.availableForEveryOne ? command.assignedUserIds.length : release.totalUserCount}} / {{release.totalUserCount}}
                                </h6>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" xl="6"><small class="text-muted">{{$t('datatables.aangemaaktop')}}</small></b-col>
                            <b-col cols="12" xl="6"><h6 class="font-weight-bold">{{release.createdAt | datetime}}</h6></b-col>
                        </b-row>
                        <hr/>
                        <small class="text-muted">{{$t('releases.uitgeroldaan')}}</small>
                        <treeselect v-model="value" :alwaysOpen="true" :multiple="true" :autoFocus="true" :options="options" :load-options="loadOptions"/>
                    </div>
                </div>
            </b-col>
        </b-row>
        <!-- Submit controls -->
        <br/>
        <b-row>
            <b-col md="12">
                <b-button @click="goTo('index')" variant="secondary">{{$t('buttons.annuleren')}}</b-button>
                <b-button type="submit" variant="themecolor">{{$t('buttons.opslaan')}}</b-button>
            </b-col>
        </b-row>
        <!-- Submit controls -->
    </b-form>
</template>

<script>
// import the component
import Treeselect from '@riophae/vue-treeselect'

// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import { mapGetters, mapActions } from 'vuex';
import Command from "./command";

import router from '@/providers/router/'

export default {
    name: 'release-detail',
    components: { Treeselect },
    data() {
        return {
            command: new Command(),
            status: 0,
             // define default value
            value: null,
            // define options
            options: [ 
                {
                    id: 'all',
                    label: this.$i18n.t('releases.alleklanten'),
                    children: []
                }
            ],            
            totalCompanies: 0
        }
    },
    computed: {
    ...mapGetters("fm", ["release"])
  },
    methods: {
        ...mapActions('fm',['find','update']),
        clearAvailableFrom() {
            this.command.availableFrom = '';
        },
        onSubmit(event) {
            event.preventDefault();
  
            const vm = this;
            if(vm.command.id) 
            {
                vm.command.assignedCompanyIds = [];
                vm.command.assignedUserIds = [];
                
                if(vm.value) 
                {
                    if(vm.value.indexOf("all") !== -1) {
                        vm.command.availableForEveryOne = true;
                    }
                    else {
                        vm.command.availableForEveryOne = false;
                        vm.value.forEach((id) => {
                            var type = id.split('_')[0];
                            var value = id.split('_')[1];
                            if(type == "company") {
                                vm.command.assignedCompanyIds.push(value);
                            }
                            else if(type == "user") {
                                vm.command.assignedUserIds.push(value);
                            }
                        });
                    }
                }
                else {
                    vm.command.availableForEveryOne = false;
                }
                vm.update({
                    resource: 'releases',
                    params: vm.command
                })
                .then(()=> {
                    vm.goTo('index');
                });
            }
        },
        goTo(name) {
            this.$router.push({ name: `releases:${name}` });
        },
        loadOptions({ callback }) {
            callback();
        }    
    },
    created() {
        const vm = this;
        vm.find({
            resource: "releases",
            id: vm.$route.params.releaseId
        }).then((data) => {
            vm.command = new Command(data);

            vm.value = [];
            if(vm.command.availableForEveryOne) {
                vm.value = ['all'];
            }
            
            vm.$store.dispatch("management/all", { resource: 'companies' })
            .then((companyResult) => 
            {
                companyResult.result.forEach((company) => 
                {
                    router.currentRoute.params.companyId = company.id;

                    vm.$store.dispatch("management/all", { resource: 'users' }).then((userResult) => 
                    {
                        let companyOption = { 
                            id: "company_"+company.id,
                            label: company.name,
                            children: userResult.result.length > 0 ? [] : null,  
                        }

                        userResult.result.forEach((user) => 
                        {
                            companyOption.children.push({ 
                                id: "user_"+user.id,
                                label: user.fullName
                            });
                            if(!vm.command.availableForEveryOne && vm.command.assignedUserIds.indexOf(user.id) !== -1) {
                                vm.value.push('user_'+user.id);
                            }
                        });

                        vm.options[0].children.push(companyOption);

                        if(!vm.command.availableForEveryOne && vm.command.assignedCompanyIds.indexOf(company.id) !== -1) {
                            var allIndex = vm.value.indexOf('all');
                            if(allIndex > -1) {
                                vm.value.splice(allIndex,1);
                            }
                            vm.value.push('company_'+company.id);
                        }
                    });
                });
            });
        });
    }
};

</script>
